import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import React, { useCallback, useState } from 'react';

import { Button } from 'ui-components/components/button';
import { Popover } from 'ui-components/components/popover';

import sharedStyle from '../style.module.css';
import { EditLotPopoverBody } from './edit-lot-popover-body';

/**
 * @param {object} props
 * @param {() => void} props.onReloadLocations
 * @param {string} props.productId
 * @param {boolean} props.isPopoverOpen
 * @param {() => void} props.onClose
 * @param {string} [props.lot]
 * @param {string} props.lotUuid
 * @param {string} [props.expirationDate]
 * @returns {JSX.Element}
 */

export const EditLotPopover = ({ onReloadLocations, productId, isPopoverOpen, onClose, lot = '', lotUuid, expirationDate = '' }) => {
  const [isOpen, setIsOpen] = useState(isPopoverOpen);
  const onOpenPopover = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [setIsOpen]);
  const onOuterAction = useCallback(() => {
    setIsOpen(false);
    onClose();
  }, [setIsOpen, onClose]);

  const editLotPopoverProps = {
    expirationDate,
    lot,
    lotUuid,
    onOuterAction,
    onReloadLocations,
    productId,
    setIsOpen,
  };

  const popoverProps = {
    isOpen,
    preferPlace: 'below',
    enterExitTransitionDurationMs: 0,
    body: <EditLotPopoverBody {...editLotPopoverProps} />,
    appendTarget: document.querySelector('#app-root'),
    onOuterAction,
  };

  return (
    <Popover {...popoverProps}>
      <Button className={sharedStyle['adjust-icon']} onClick={onOpenPopover} theme='link'>
        {!isPopoverOpen && <FontAwesomeIcon className={sharedStyle.icon} icon={faPlus} />}
      </Button>
    </Popover>
  );
};
